import React from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

import Dialog from '@/components/Dialog';
import { Select } from '@/components/FormAdapters/FormAdapters';

function AttachToExpertRequest({
  onCancel,
  open,
  onConfirm,
  consultation,
  initialValues,
  expertRequests,
}: any) {
  const { expert_request: expertRequest } = consultation;

  const title = !expertRequest
    ? 'Add Consultation to an Expert Request'
    : 'Edit Associated Expert Request';

  const confirmLabel = !expertRequest ? 'Add to Expert Request' : 'Edit Expert Request';

  return (
    <Form onSubmit={onConfirm} initialValues={initialValues}>
      {({ form, handleSubmit }) => {
        const handleReset = () => {
          form.reset();
          if (onCancel) onCancel();
        };

        return (
          <Dialog
            useForm
            open={open}
            title={title}
            onSubmit={handleSubmit}
            onReset={() => form.reset()}
            onClose={handleReset}
            onCancel={handleReset}
            cancelLabel="Cancel"
            confirmLabel={confirmLabel}
          >
            <Field
              autocomplete
              component={Select}
              label="Select the Expert Request"
              name="expert_request_id"
              options={expertRequests.edges.map((p: any) => ({
                value: p.node.id,
                label: p.node.name,
              }))}
            />
          </Dialog>
        );
      }}
    </Form>
  );
}

// @ts-expect-error TS(2630) FIXME: Cannot assign to 'AttachToExpertRequest' because i... Remove this comment to see the full error message
AttachToExpertRequest = connect((state, ownProps) => {
  const expertRequestId =
    // @ts-expect-error TS(2339) FIXME: Property 'consultation' does not exist on type '{}... Remove this comment to see the full error message
    ownProps.consultation &&
    // @ts-expect-error TS(2339) FIXME: Property 'consultation' does not exist on type '{}... Remove this comment to see the full error message
    ownProps.consultation.expert_request &&
    // @ts-expect-error TS(2339) FIXME: Property 'consultation' does not exist on type '{}... Remove this comment to see the full error message
    ownProps.consultation.expert_request.id;
  return {
    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    expertRequests: state.expertRequests.all,
    initialValues: {
      expert_request_id: expertRequestId,
    },
  };
})(AttachToExpertRequest);

export default AttachToExpertRequest;
